import { render } from "./Chart.vue?vue&type=template&id=3a6525fa&scoped=true&ts=true"
import script from "./Chart.vue?vue&type=script&lang=ts"
export * from "./Chart.vue?vue&type=script&lang=ts"

import "./Chart.vue?vue&type=style&index=0&id=3a6525fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6525fa"]])

export default __exports__